import React, {Component} from 'react';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import storageNutritionAllergenBG from '../media/newstoragebackground.jpg';
import paper1 from '../media/unlinedpaper.jpg';
import paper2 from '../media/unlinedpaper.jpg'
import paper3 from '../media/unlinedpaper.jpg'

const StorageNutritionAllergenSection = (props) => {

	return (
	  <FluidContainer fluid>
	    <InternalContainer>
		  <h1>Maple Storage, Nutrition, and Allergen Information</h1>
		  <PaperImgsRow>
			<PaperImgCol1 xs="12" xl="4">
				<div>
					<h3>Corn Allergy</h3>
					<h4>Do you or someone you know have a corn allergy?</h4>
					<p>No problem! We offer corn-free packaging upon request. Simply choose 'corn-free-packaging' in checkout or 
					contact us about your order below.</p>
				  	<Link to="/Contact">
					  	<ButtonStyled>
							<p>Request corn-free</p>
						</ButtonStyled>
				  	</Link>
				</div>
				{/*<PaperImg src={require("../media/paper1.jpg")}></PaperImg>*/}
			</PaperImgCol1>
			<PaperImgCol2 xs="12" xl="4">
				<div>
					<h3>Health Benefits</h3>
					<h4>Did you know maple syrup has numerous health benefits?</h4>
					<p>That's right! Compared to other syrups and many other foods, maple syrup is healthier with many health benefits.</p>
				  	<Link to="/Nutrition">
					  	<ButtonStyled>
							<p>Find out more</p>
						</ButtonStyled>
				  	</Link>
				</div>
				{/*<PaperImg src={require("../media/paper1.jpg")}></PaperImg>*/}
			</PaperImgCol2>
			<PaperImgCol3 xs="12" xl="4">
				<div>
					<h3>Shelf Life</h3>
					<h4>Want to make sure your maple syrup and products last?</h4>
					<p>We have a bunch of tips on storing your syrup and maple products. Ensure your maple stays fresh!</p>
				  	<Link to="/Storage">
					  	<ButtonStyled>
							<p>Find out more</p>
						</ButtonStyled>
				  	</Link>
				</div>

				{/*<PaperImg src={require("../media/paper1.jpg")}></PaperImg>*/}
			</PaperImgCol3>
		  </PaperImgsRow>

		  
	    </InternalContainer>
	  </FluidContainer>
	); 
};

const PaperImgsRow = styled(Row)`
	h3 { padding: 0px 0 24px 0; margin: 0; }
	h4 { font-weight: bold!important; }
`;

const PaperImgCol1 = styled(Col)`
	margin: 0 0 20px 0;
	${media.xl` margin: 0; `}

	div {  background-image: url(${paper1});  padding: 20px 12px 20px 12px; }
`;
const PaperImgCol2 = styled(Col)`
	margin: 0 0 20px 0;
	${media.xl` margin: 0; `}

	div {  background-image: url(${paper2});  padding: 20px 12px 20px 12px; }
`;
const PaperImgCol3 = styled(Col)`
	margin: 0 0 20px 0;
	${media.xl` margin: 0; `}

	div {  background-image: url(${paper3});  padding: 20px 12px 20px 12px; }
`;

const PaperImg = styled.img`
	height: auto;
	width: 100%;
	position: absolute;

`;

const FluidContainer = styled(Container)`
	padding: 20px 0 20px 0!important;
	background-image: url(${storageNutritionAllergenBG}); 
	
	/*
    background-size: 100%; /* size the background image at 100% like any responsive img tag */
    background-position: top center;
    background-repeat:no-repeat;
    */
`;

const InternalContainer = styled(Container)`
	text-align: center;
	h1 { 
		margin: 0 0 20px 0;
		color: white;
	}
`;

const ButtonStyled = styled(Button)`
  cursor: pointer;
  display: block;
  border: 0px!important;
  color: white!important;
  font-weight: bold!important;
  background-color: #800000!important;
  width: 250px;
  ${media.sm` width: 290px; `}
  
  height: 40px;
  line-height: 20px!important;
  transition: all 0.5s;
  margin: 15px 0 0 0;

  p {
    cursor: pointer;
    display: inline;
    position: relative;
    transition: 0.5s;
  }

  p:after {
    content: '\00bb';
    position: absolute;
    opacity: 0;
    right: -20px;
    transition: 0s;
  }

  :hover p { padding-right: 25px; }
  :hover p:after { opacity: 1; right: 0; }
  :active p:after { opacity: 0; }
  :active { box-shadow: 0 5px #666; transform: translateY(6px); }
`;

/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
  display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/

export default StorageNutritionAllergenSection;


// WEBPACK FOOTER //
// ./src/components/StorageNutritionAllergenSection.js